module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reset":"Reset","go":"Go There"},"ja":{"reset":"リセット","go":"表示"}}')
  delete Component.options._Ctor
}
